const ccBenefitsSlideshowOptions = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  mobileFirst: true,
  autoplay: false,
  dots: false,
  initialSlide: 1,
  centerMode: true,
  arrows: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 590,
      settings: {
        centerPadding: '160px'
      }
    },
    {
      breakpoint: 1023,
      settings: 'unslick'
    }
  ]
};

const ccSlideshow = document.querySelector(
  '.section-coffee-club-benefits-carousel .benefits-carousel__items'
);

function stripSlickSlideAria(slideshow) {
  if (!slideshow) return;

  slideshow.querySelectorAll('.slick-slide').forEach(slide => {
    slide.removeAttribute('role');
    slide.removeAttribute('aria-label');
  });
}

if (ccSlideshow) {
  $(ccSlideshow).on('init reInit', function () {
    stripSlickSlideAria(ccSlideshow);
  });

  $(ccSlideshow).slick(ccBenefitsSlideshowOptions);
}

window.addEventListener('resize', function () {
  if (!ccSlideshow) return;
  if (
    window.innerWidth < 1024 &&
    !ccSlideshow.classList.contains('slick-initialized')
  ) {
    $(ccSlideshow).slick(ccBenefitsSlideshowOptions);
    stripSlickSlideAria(ccSlideshow);
  }
});
